import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function TSHForm() {
  const [form, setForm] = useState({
    name: "",
    ageSex: "",
    doctor: "",
    date: "",

    tsh: "",
    t3: "",
    t4: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <>
      <div className="container my-3">
        <h3>IMMUNOLOGY - TSH / T3 / T4 FORM</h3>

        <div className="row mb-2">
          <div className="col-md-6">
            <label>Pt. Name:</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={form.name}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6">
            <label>Age/Sex:</label>
            <input
              type="text"
              className="form-control"
              name="ageSex"
              value={form.ageSex}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-md-6">
            <label>Ref. by Dr.:</label>
            <input
              type="text"
              className="form-control"
              name="doctor"
              value={form.doctor}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6">
            <label>Date:</label>
            <input
              type="date"
              className="form-control"
              name="date"
              value={form.date}
              onChange={handleChange}
            />
          </div>
        </div>

        <h5 className="mt-4">INVESTIGATION</h5>
        {[
          ["TSH (mIU/L)", "tsh"],
          ["T3 (Total) (ug/dl)", "t3"],
          ["T4 (Total) (nmol/L)", "t4"],
        ].map(([label, name]) => (
          <div className="mb-2" key={name}>
            <label>{label}:</label>
            <input
              type="text"
              className="form-control"
              name={name}
              value={form[name]}
              onChange={handleChange}
            />
          </div>
        ))}

        <p className="mt-3">
          <strong>Method:</strong> SD BIOSENSOR ANALYZER
        </p>

        <button className="btn btn-primary mt-3" onClick={() => window.print()}>
          🖨️ Print Report
        </button>
      </div>

      {/* Printable Report */}
      <div
        className="print-area container py-4"
        style={{ fontFamily: "Arial", fontSize: "14px" }}
      >
        <h2 className="text-center text-decoration-underline">
          IMMUNOLOGY REPORT - TSH / T3 / T4
        </h2>

        <div className="row mb-2">
          <div className="col-6">
            <strong>Pt. Name:</strong> {form.name}
          </div>
          <div className="col-6">
            <strong>Age/Sex:</strong> {form.ageSex}
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-6">
            <strong>Ref. by Dr.:</strong> {form.doctor}
          </div>
          <div className="col-6">
            <strong>Date:</strong> {form.date}
          </div>
        </div>

        <h5 className="text-decoration-underline">INVESTIGATION</h5>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td>TSH</td>
              <td>{form.tsh}</td>
              <td>mIU/L</td>
            </tr>
            <tr>
              <td>T3 (Total)</td>
              <td>{form.t3}</td>
              <td>ug/dl</td>
            </tr>
            <tr>
              <td>T4 (Total)</td>
              <td>{form.t4}</td>
              <td>nmol/L</td>
            </tr>
          </tbody>
        </table>

        <p className="mt-3">
          <strong>Method:</strong> SD BIOSENSOR ANALYZER
        </p>

        <p className="text-end mt-4">
          <strong>*****END OF REPORTS*****</strong> &nbsp;&nbsp;&nbsp;&nbsp;
          Technologist
        </p>
      </div>
    </>
  );
}

export default TSHForm;
